import { makeImmutable } from "../../core/makeImmutable";
export class OrderLineReference {
    constructor(params) {
        this.orderLineIndex = params.orderLineIndex;
        this.productInstanceIndex = params.productInstanceIndex;
        this.productInstance = params.productInstance;
        makeImmutable(this);
    }
    static fromStorageData({ purchaseOrderPayload, storageData, }) {
        const orderLine = purchaseOrderPayload.orderLines.get(storageData.orderLineIndex);
        if (orderLine.id.value !== storageData.productInstanceId) {
            throw new Error("Order line reference id mismatch");
        }
        if (storageData.productInstanceIndex >= orderLine.quantity.value) {
            throw new Error("Invalid product instance index in deserialized order line reference");
        }
        return new OrderLineReference({
            orderLineIndex: storageData.orderLineIndex,
            productInstanceIndex: storageData.productInstanceIndex,
            productInstance: orderLine.productInstance,
        });
    }
    eq(other) {
        return (this.orderLineIndex === other.orderLineIndex &&
            this.productInstanceIndex === other.productInstanceIndex &&
            this.productInstance.id.eq(other.productInstance.id));
    }
    get checkoutData() {
        return {
            productGroupIndex: this.orderLineIndex,
            // NOTICE productSequenceNum is 1-indexed on backend
            productSequenceNum: this.productInstanceIndex + 1,
        };
    }
    get storageData() {
        return {
            orderLineIndex: this.orderLineIndex,
            productInstanceIndex: this.productInstanceIndex,
            productInstanceId: this.productInstance.id.value,
        };
    }
    get price() {
        return this.productInstance.price;
    }
}
